module.exports = __webpack_public_path__ + "img/editBlock.2f22abc6.svg";